import { useEffect, useState,  type JSX } from "react";


import { useUpdateDemandeMutation } from "../../stores/OkOkStore";

import { FloatingTextareaBootstrap } from "../Common/FloatingInputBootstrap";
import { useForm } from "react-hook-form";

import type { ResponseError } from "../../types/CommonReponse";
import type { Demande, DemandeOperatorUpdate, demandeStatus } from "../../types/Demande";
import { StatutSelectorBootstrap } from "../Common/StatutSelectorBootstrap";
import { useTrads } from "../../contexts/trads/useTrads";
import { Navigate } from "react-router";


interface Props  {
    demandeParam: Demande;
};
 function  DemandeManage ({demandeParam}: Props): JSX.Element {
    
    const [updateDemande, result] = useUpdateDemandeMutation();
    console.log(result);
    const [hasComment, setHasComment]=useState(false);
    const {translate}=useTrads();



    const demande:DemandeOperatorUpdate={...demandeParam}


    const { register, handleSubmit,watch,setValue,setError, formState: { errors }  } = useForm({
        defaultValues:demande,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });

    const statut=watch('statut');


    useEffect(()=>{
        if((statut=='attente' as demandeStatus || statut=='refuse' as demandeStatus)){
            setHasComment(true);
        } else {
            setHasComment(false)
            setValue('comment','');
        }
        
    },[statut,setValue,setHasComment,translate]);
    

    const onSubmit=function(demande:DemandeOperatorUpdate){
        return updateDemande(demande);
    }

    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result,translate]);

    return (
        result.isSuccess ? <span><Navigate to={`/demande/${result.data.id.toString()}`} state={{modified:"true"}}></Navigate></span> :(
        result.error && 'status' in result.error && result.error.status!=400 ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>:
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <>
        <form className="row" onSubmit={(event) => void handleSubmit(onSubmit)(event)}>

            <div className="col-12  mb-3">
                <StatutSelectorBootstrap

                    name="statut"
                    label={translate('demande_statut')}
                    errors={errors}
                    registerOutput={register("statut", {
                        required: translate("demande_error_statut_requis"),
                    })}
                    statut={demandeParam.statut}

                />
            </div>
            
            {hasComment?
            <div className="col-12  mb-3">
            <FloatingTextareaBootstrap 
                name="comment"
                label={translate('demande_comment')}
                errors={errors}
                registerOutput={register("comment", {
                    
                })}
            />
            </div>
            :null
            }


            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        </>
        )
    );
}
export default DemandeManage;